<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Ticket Type' : 'Add Ticket Type' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <ion-label class="input-label"> Name </ion-label>
    <ion-input #nameInput placeholder="e.g. IT Support Request" [(ngModel)]="name" class="input-field"> </ion-input>
    <div class="subtitle pull-right" *ngIf="id && !aliases?.length">
      <a (click)="showAddAliasPopup()">Add an alias</a>
      <ion-icon
        name="information-circle"
        class="icon-padded-left"
        ngxTippy
        data-tippy-content="Alternative names that users can search for to find this ticket type. Type an alias and press Enter to add it."
      ></ion-icon>
    </div>
    <div *ngIf="aliases.length > 0" style="margin-bottom: 10px">
      <ion-label class="input-label">
        Aliases (optional)
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          data-tippy-content="Aliases are alternative names that users can search for to find this ticket type."
        ></ion-icon>
      </ion-label>
      <div style="display: flex; flex-wrap: wrap; gap: 6px" *ngIf="id && aliases.length > 0">
        <ion-chip
          *ngFor="let alias of aliases; let i = index"
          mode="ios"
          color="primary"
          class="chip tag-chip no-margin"
          (click)="removeAlias(i)"
        >
          <ion-label>{{ alias }}</ion-label>
          <ion-icon name="close-circle" style="font-size: 0.7rem; margin: 4px"></ion-icon>
        </ion-chip>
        <ion-chip
          mode="ios"
          color="primary"
          class="chip tag-chip tag-chip-light clickable no-margin"
          (click)="showAddAliasPopup()"
        >
          <ion-label>
            <ion-icon name="add-outline"></ion-icon>
          </ion-label>
        </ion-chip>
      </div>
    </div>
    <ion-label class="input-label">
      Description (private)
      <ion-icon
        name="information-circle"
        class="icon-padded-left"
        ngxTippy
        data-tippy-content="Add a helpful description to be used internally or by the AI to automatically select this ticket type from a user's query. This is not visible to end users."
      ></ion-icon>
    </ion-label>
    <ion-textarea
      placeholder="e.g. Issues related to information technology and hardware"
      [(ngModel)]="description"
      class="input-field"
      rows="3"
      [autoGrow]="true"
    >
    </ion-textarea>

    <h2 class="input-section-header">Custom Fields</h2>
    <div class="input-section-divider"></div>
    <div style="margin: 0 -10px">
      <app-custom-fields
        *ngIf="fields"
        [customFields]="fields"
        [placeholder]="'Ex: Favorite color'"
        [addCustomFieldButtonLabel]="'Add a custom ticket field'"
        [showPublicOption]="true"
        [showUserAttributeOption]="false"
        [showBranchingInput]="true"
        [showDescription]="true"
        contextPrefix="conversation.ticketTypeFields"
        [readOnly]="true"
        [projectId]="projectId"
      >
      </app-custom-fields>
    </div>

    <h2 class="input-section-header">Ticket Submission Options</h2>
    <div class="input-section-divider"></div>
    <ion-card class="outline-card" style="margin: 10px 0">
      <ion-list class="no-padding">
        <ion-item>
          <ion-label class="input-label">
            <ion-icon name="eye-outline" class="padded-icon button-icon"></ion-icon>
            Visibility to end users
            <ion-icon
              name="information-circle"
              class="icon-padded-left"
              ngxTippy
              data-tippy-content="Configure whether end users are able to see or submit tickets of this type"
            ></ion-icon>
          </ion-label>
          <div class="pill-tab-container">
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': visibility === 'hidden'
              }"
              style="font-size: 0.7rem"
              (click)="visibility = 'hidden'"
            >
              Hidden
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active': visibility === 'display_only'
              }"
              style="font-size: 0.7rem"
              (click)="visibility = 'display_only'"
            >
              Display Only
            </div>
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': visibility === 'submittable'
              }"
              style="font-size: 0.7rem"
              (click)="visibility = 'submittable'"
            >
              Submittable
            </div>
          </div>
        </ion-item>
        <ion-item [hidden]="visibility !== 'submittable'">
          <ion-label class="input-label">
            <ion-icon name="star-outline" class="padded-icon button-icon"></ion-icon>
            Show user-provided priority field
            <ion-icon
              name="information-circle"
              class="icon-padded-left"
              ngxTippy
              data-tippy-content="Option for the user to provide a priority level"
            ></ion-icon>
          </ion-label>
          <div class="pill-tab-container">
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': prioritySelector === 0
              }"
              style="font-size: 0.7rem"
              (click)="prioritySelector = 0"
            >
              Disabled
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active': prioritySelector === 1
              }"
              style="font-size: 0.7rem"
              (click)="prioritySelector = 1"
            >
              Optional
            </div>
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': prioritySelector === 2
              }"
              style="font-size: 0.7rem"
              (click)="prioritySelector = 2"
            >
              Required
            </div>
          </div>
        </ion-item>
        <ion-item [hidden]="visibility !== 'submittable'">
          <ion-label class="input-label">
            <ion-icon name="text-outline" class="padded-icon button-icon"></ion-icon>
            Show user-provided title field
            <ion-icon
              name="information-circle"
              class="icon-padded-left"
              ngxTippy
              data-tippy-content="Option for the user to provide a title for the ticket"
            ></ion-icon>
          </ion-label>
          <div class="pill-tab-container">
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': titleInput === 0
              }"
              style="font-size: 0.7rem"
              (click)="titleInput = 0"
            >
              Disabled
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active': titleInput === 1
              }"
              style="font-size: 0.7rem"
              (click)="titleInput = 1"
            >
              Optional
            </div>
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': titleInput === 2
              }"
              style="font-size: 0.7rem"
              (click)="titleInput = 2"
            >
              Required
            </div>
          </div>
        </ion-item>
        <ion-item [hidden]="visibility !== 'submittable'">
          <ion-label class="input-label">
            <ion-icon name="document-text-outline" class="padded-icon button-icon"></ion-icon>
            Show user-provided description field
            <ion-icon
              name="information-circle"
              class="icon-padded-left"
              ngxTippy
              data-tippy-content="Option for the user to provide a description for the ticket"
            ></ion-icon>
          </ion-label>
          <div class="pill-tab-container">
            <div
              class="round-pill-tab round-pill-tab-left"
              [ngClass]="{
                'round-pill-tab-active': descriptionInput === 0
              }"
              style="font-size: 0.7rem"
              (click)="descriptionInput = 0"
            >
              Disabled
            </div>
            <div
              class="round-pill-tab"
              [ngClass]="{
                'round-pill-tab-active': descriptionInput === 1
              }"
              style="font-size: 0.7rem"
              (click)="descriptionInput = 1"
            >
              Optional
            </div>
            <div
              class="round-pill-tab round-pill-tab-right"
              [ngClass]="{
                'round-pill-tab-active': descriptionInput === 2
              }"
              style="font-size: 0.7rem"
              (click)="descriptionInput = 2"
            >
              Required
            </div>
          </div>
        </ion-item>
      </ion-list>
    </ion-card>

    <ng-container *ngIf="visibility !== 'hidden'">
      <ion-label class="input-label">
        Note displayed to user when selected (optional)
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          data-tippy-content="This is static text that will be displayed to the user when they select this ticket type. Helpful for providing instructions or context."
        ></ion-icon>
      </ion-label>
      <app-tiptap-editor
        [(ngModel)]="userFormNote"
        placeholder="e.g. Please provide the following info..."
        [enableLinkEditing]="true"
        [showToolbar]="true"
        class="input-field"
      >
      </app-tiptap-editor>
      <!-- Wrap the entire Ticket Posting section -->
      <ng-container *ngIf="isTicketSpecificPostingEnabled">
        <div class="input-section">
          <ion-label class="input-label">
            Where to post ticket details
            <ion-icon
              name="information-circle"
              class="icon-padded-left"
              ngxTippy
              data-tippy-content="Choose where to post ticket details when submitted. Note that tickets created via Bot DMs will not be affected by this setting."
            ></ion-icon>
          </ion-label>
          <ion-select
            [(ngModel)]="postingDestinationMode"
            interface="popover"
            class="select-outline input-field"
            placeholder="Select a posting destination mode"
            aria-label="Posting destination mode"
          >
            <ion-select-option *ngFor="let mode of postingDestinationModes" [value]="mode.value">{{
              mode.label
            }}</ion-select-option>
          </ion-select>

          <ng-container *ngIf="postingDestinationMode === POSTING_DESTINATION_MODES.TICKET_TYPE_SPECIFIC_CHANNEL">
            <ion-label class="input-label">
              Allowed Channels
              <ion-icon
                name="information-circle"
                class="icon-padded-left"
                ngxTippy
                data-tippy-content="Specify which channels this ticket type will be posted to. Selecting multiple channels will allow the user to choose from a dropdown."
              ></ion-icon>
            </ion-label>
            <div style="padding: 10px 0">
              <ion-chip
                *ngFor="let channel of postingDestinationChannels"
                mode="ios"
                color="dark"
                class="chip tag-chip"
                style="margin: 0 3px"
                (click)="removePostingDestinationChannel(channel)"
              >
                <ion-label style="display: flex; align-items: center">
                  {{ channel.name }}
                  <ion-icon name="close-circle-outline" class="icon-padded-left button-icon"></ion-icon>
                </ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                color="dark"
                class="chip tag-chip tag-chip-light"
                (click)="addPostingDestinationChannel()"
                style="background: transparent; cursor: pointer"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Add channel'
                }"
              >
                <ion-label>
                  <ion-icon name="add-outline"></ion-icon>
                </ion-label>
              </ion-chip>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <!-- End of feature-flagged section -->
    </ng-container>

    <ng-container
      *ngIf="
        authService.tenant.integrations?.pagerDuty?.enabled &&
        authService.tenant.integrations?.pagerDuty?.enableTicketTypeRouting
      "
    >
      <h2 class="input-section-header">Integrations</h2>
      <div class="input-section-divider"></div>
      <ion-label class="input-label">
        PagerDuty Service ID
        <ion-icon
          name="information-circle"
          class="icon-padded-left"
          ngxTippy
          data-tippy-content="The PagerDuty service ID that will be used for pages for this ticket type"
        ></ion-icon>
      </ion-label>
      <div>
        <ion-chip
          mode="ios"
          class="no-margin select-chip select-outline input-field"
          [outline]="true"
          (click)="showPagerDutyServiceOptions()"
        >
          <ion-label>
            {{ pagerDutyService?.name ?? 'None' }}
            <ion-icon name="chevron-down-outline" class="icon-padded-left chevron-icon"></ion-icon>
          </ion-label>
        </ion-chip>
      </div>
    </ng-container>

    <h2 class="input-section-header">AI Bot Configuration</h2>
    <div class="input-section-divider"></div>
    <div>
      <div class="input-section">
        <ion-label class="input-label">
          Additional AI Prompt Instructions
          <ion-icon
            name="information-circle"
            class="icon-padded-left"
            ngxTippy
            data-tippy-content="Additional prompt instructions for the model regarding this topic. These instructions will be used in key parts of the agent. (i.e., when to escalate, how to respond, reactions to specific keywords)"
          ></ion-icon>
        </ion-label>
        <div class="input-field">
          <ion-textarea
            [(ngModel)]="instructions"
            style="margin-top: 0"
            rows="3"
            placeholder="e.g. If the user asks for a new laptop, respond with 'I've created a ticket for you. It will be delivered to your desk tomorrow.'"
            [autoGrow]="true"
          ></ion-textarea>
          <ion-button
            [ngClass]="{
              isSuggestingInstruction: isSuggestingInstruction
            }"
            (click)="suggestTopicInstruction()"
            [hidden]="instructions?.length"
            class="btn-small"
            [disabled]="isSuggestingInstruction"
            style="margin: 8px"
          >
            ✨ Suggest sample instructions
            <span class="ai-magic-overlay linear-gradient-subtle-animated"></span>
          </ion-button>
        </div>
      </div>

      <ng-container *ngIf="isDev">
        <ion-label class="input-label"> Tools </ion-label>
        <ion-card *ngFor="let tool of tools; let i = index; trackBy: arrayTrackBy">
          <ion-card-header class="flex-space-between" style="margin-bottom: -16px">
            <ion-card-subtitle style="margin-top: 10px">{{ tool?.automation?.name ?? 'Automation' }}</ion-card-subtitle>
            <ion-button fill="clear" color="dark" (click)="removeAutomation(tool)">
              <ion-icon name="trash-outline"></ion-icon>
            </ion-button>
          </ion-card-header>
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="input-label">Tool</ion-label>
                <ion-button *ngIf="!tool.automationId" color="light" (click)="selectAutomation(tool)" slot="end">
                  <ion-icon name="flash-outline" class="padded-icon button-icon"></ion-icon>
                  Select an automation
                  <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
                </ion-button>
                <ion-button *ngIf="tool.automationId" color="light" (click)="selectAutomation(tool)" slot="end">
                  <ion-icon name="flash-outline" class="padded-icon button-icon"></ion-icon>
                  {{ tool?.automation?.name ?? 'Automation' }}
                </ion-button>
              </ion-item>

              <ion-item>
                <ion-label class="input-label">Description</ion-label>
                <ion-input [(ngModel)]="tool.description" slot="end"></ion-input>
              </ion-item>

              <ion-item>
                <ng-container>
                  <ion-label class="input-label">Approver</ion-label>
                  <ion-button *ngIf="tool.approverId" color="light" (click)="removeEntity(tool)" slot="end">
                    <ion-avatar class="user-photo">
                      <app-avatar size="25" [name]="tool.approver?.name" [image]="tool?.approver?.photo"></app-avatar>
                    </ion-avatar>
                    {{ tool.approver?.name }}
                    <ion-icon
                      name="close-circle-outline"
                      style="margin-left: 25px"
                      class="padded-icon button-icon"
                    ></ion-icon>
                  </ion-button>
                  <ion-button *ngIf="!tool.approverId" color="light" (click)="selectEntity(tool)" slot="end">
                    Select
                  </ion-button>
                </ng-container>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>
        <br />
        <ion-button (click)="addNewTool()" color="light" class="button-small">
          <ion-icon name="add"></ion-icon>
          Add new integration
        </ion-button>
        <hr />
      </ng-container>

      <!-- This section remains outside the *ngIf -->
      <ion-label class="input-label">For Bot DM-created tickets, post admin details to channel:</ion-label>
      <br />
      <app-channel-selector
        [channel]="defaultSlackChannel"
        (channelDidChange)="onSlackChannelChanged($event)"
        [defaultInternalOnly]="true"
        [initialButtonText]="'Default (Project-level triage channel)'"
      ></app-channel-selector>
      <ng-container *ngIf="!authService.tenant.accountsEnabled">
        <ion-label class="input-label"> Default Customer </ion-label>
        <br />
        <ion-button *ngIf="!defaultCustomer?.name" fill="outline" (click)="selectCustomer()">
          <ion-icon name="business-outline" class="padded-icon button-icon"></ion-icon>
          Link to Customer:
          <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
        </ion-button>
        <ion-button *ngIf="defaultCustomer?.name" color="light" (click)="selectCustomer()">
          <ion-icon name="business" class="padded-icon button-icon"></ion-icon>
          {{ defaultCustomer.name }}
        </ion-button>
        <ion-button color="danger" fill="clear" (click)="unlinkCustomer()" *ngIf="defaultCustomer"> Unlink </ion-button>
        <br />
        <br />
      </ng-container>
      <ion-label class="input-label">
        <a href="https://docs.unthread.io/conversations/slack-bot" target="_blank">
          <ion-icon name="book-outline" class="padded-icon"></ion-icon>
          <span>Learn more about Bot DMs</span>
        </a>
      </ion-label>
    </div>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="duplicate()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Duplicate"
      style="margin-left: 10px"
    >
      <ion-icon name="duplicate-outline"></ion-icon>
    </ion-button>

    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
